import { djangoClientQueryFactory } from "api/client/helpers/queryFactory";
import assert from "assert";
import { SerializedSideEffects } from "pages/gdt/store/SideEffects";

export const gdtAnalysisTableReorderRows = djangoClientQueryFactory(
  {
    method: "patch",
    path: "/library/gdt_analysis_table/reorder_rows/{id}/",
  },
  {
    formatInput: (
      tableId: string,
      {
        orderedRowIds,
        sideEffects,
      }: { orderedRowIds: string[]; sideEffects: SerializedSideEffects },
    ) => {
      return {
        params: { path: { id: tableId } },
        body: {
          rows: orderedRowIds,
          side_effects: sideEffects,
        },
      };
    },
    handleResponse: (res) => {
      const data = res.data;
      assert(data !== undefined, "Expected data to be defined");
      return data;
    },
  },
);
